window.addEventListener('CookiebotOnConsentReady', function () {
	// Select the .chat-icon element
	const chatIcon = document.querySelector('.chat-icon');
	const consent = Cookiebot.consent.statistics;
	console.debug('Cookiebot statistics consent:', consent);

	// The else branch previously dereferenced chatIcon without the guard the if has,
	// so any page without the partial threw here and skipped the listener below.
	if (chatIcon) {
		chatIcon.classList.toggle('enabled', !consent);
	}

	const changeConsent = document.querySelector('#fake-chat-change-consent');

	if (changeConsent) {
		changeConsent.addEventListener('click', function () {
			Cookiebot.renew();
		});
	}
});
